import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTaskTablesContext } from '../context';
import { TaskTableStatus } from '../types';
import { Header } from './Header';
import { All, Archived, Done, InProgress, Snoozed, Unassigned } from './tables';

export const TaskTables: React.FC = React.memo(function TaskTables() {
  useTranslation(['backend', 'common', 'serviceDashboard', 'adTags', 'messages']);
  const { status } = useTaskTablesContext();

  const table = React.useMemo(() => {
    switch (status) {
      case TaskTableStatus.ALL:
        return <All />;
      case TaskTableStatus.UNASSIGNED:
        return <Unassigned />;
      case TaskTableStatus.IN_PROGRESS:
        return <InProgress />;
      case TaskTableStatus.SNOOZED:
        return <Snoozed />;
      case TaskTableStatus.DONE:
        return <Done />;
      case TaskTableStatus.ARCHIVED:
        return <Archived />;
      default:
        return null;
    }
  }, [status]);

  return (
    <>
      <Header />
      {table}
    </>
  );
});
